export default {
  inject: ['load'],
  data() {
    return {
      allChestPainTypesForOther: [],
      chestPainType: null,
    };
  },
  methods: {
    getListOfChestPainTypesForOther: function () {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getAllChestPainTypes').then(() => {
        if (this.$store.state.chestPainTypeModule.successFlag) {
          this.allChestPainTypesForOther = this.$store.state.chestPainTypeModule.allChestPainTypes;
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.chestPainTypeModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getListOfChestPainTypesForOther();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    getChestPainTypeFunction: function (id) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getChestPainType', id).then(() => {
        if (this.$store.state.chestPainTypeModule.successFlag) {
          this.chestPainType = this.$store.state.chestPainTypeModule.chestPainType;
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.chestPainTypeModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getChestPainTypeFunction(id);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    showError: function () {
      this.snackText = this.$store.state.chestPainTypeModule.error;
      this.$refs.snackRef.snackModel = true;
      this.snackColor = '#FF5252';
      this.snakIcon = 'mdi-information';
    },
  },
};
